import React, {useState} from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import {LayoutChangeEvent, StyleSheet, View} from 'react-native';
import {Routes, Screens} from '.';
import {LoginScreen} from '../../screens/login';
// import {PollsMainScreen} from '../../screens/polls/main';
import {SocialSupportMeasuresScreen} from '../../screens/socialSupportMeasures';
import {SupportServiceScreen} from '../../screens/supportService';
import {CardServicesScreen} from '../../screens/cardServices';
import Menu from '../components/menu';
import {desktopRoutes as profileRoutes} from './profile';
import {TransportServicesScreen} from '../../screens/transportService';
import {BankServicesScreen} from '../../screens/bankService';
// import {PrivilegesScreen} from '../../screens/privileges';
import {useDispatch, useSelector} from 'react-redux';
import {holderProfileSelector, profileTokenSelector} from '../../redux/selectors/profile';
import {StateAssignmentsScreen} from '../../screens/stateAssignments';
import {StateProgramsScreen} from '../../screens/statePrograms';
import {ExpenseLiabilitiesScreen} from '../../screens/expenseLiabilities';
import MainScreen from '../../screens/main';
import {PrivilegeDetailsScreen} from '../../screens/privilegesDetails';
import {VisuallyImpairedDesktop} from '../components/visuallyImpairedDesktop';
import {SupportServiceTopics} from '../../screens/supportService/components/topics';
import {PrivilegesResolver} from '../resolvers/privilegesResolver';
import {CreateRequest} from '../../screens/supportService/components/createRequest';
import {SupportServiceTopic} from '../../screens/supportService/components/topic';
// import {PollsTypeSurveyScreen} from '../../screens/polls/surveys';
// import {PollsTypeVoteScreen} from '../../screens/polls/votes';
// import {PollsResolver} from '../resolvers/pollsResolver';
import {NotificationsScreen} from '../../screens/notifications';
import {NewsScreen} from '../../screens/news';
import {themeSelector} from '../../redux/selectors/runtime/theme';
// import {PollsTypeVoteFormScreen} from '../../screens/polls/voteForm';
// import {PollsTypeSurveyFormScreen} from '../../screens/polls/surveyForm';
// import {PollDetailsResolver} from '../resolvers/pollDetailsResolver';
// import {PollDetailsTypeResolver} from '../resolvers/pollDetailsTypeResolver';
import {NewsArticleScreen} from '../../screens/newsArticle';
import {LoyaltyProgramScreen} from '../../screens/loyaltyProgram';
import {NoInternetNotification} from '../components/noInternetNotification';
import {CardBlockedNotification} from '../components/cardBlockedNotification';
import {LoyaltyProgramAcceptorScreen} from '../../screens/loyaltyProgramAcceptor';
import {initialLoading} from './navigation';
import {TransportCardReplenishmentHistoryScreen} from '../../screens/transportCardReplenishmentHistory';
import {VolunteersServiceScreen} from '../../screens/volunteersService';
import {VolunteersServiceExchangeHistoryScreen} from '../../screens/volunteersService/components/volunteersProgram/VolunteersServiesExchangeHistory';

const unauthorizedRoutes = [
  {
    route: Screens.Login,
    webRoute: Routes.login,
    component: LoginScreen,
    title: 'Вход в систему',
  },
];

const rootRoutes = [
  {
    route: Screens.Main,
    webRoute: Routes.main,
    component: MainScreen,
    title: 'Единая карта жителя',
  },
  {
    route: Screens.CardServices,
    webRoute: Routes.cardService,
    component: CardServicesScreen,
    title: 'Возможности карты',
  },
  {
    route: Screens.TransportService,
    webRoute: Routes.transportService,
    component: TransportServicesScreen,
    title: 'Транспортное приложение',
  },
  {
    route: Screens.TransportCardReplenishmentHistory,
    webRoute: Routes.transportCardReplenishmentHistory,
    component: TransportCardReplenishmentHistoryScreen,
    title: 'История пополнений транспортной карты',
  },
  {
    route: Screens.BankingService,
    webRoute: Routes.bankingService,
    component: BankServicesScreen,
    title: 'Банковские сервисы',
  },
  // {
  //   route: Screens.PrivilegesService,
  //   webRoute: Routes.privilegesService,
  //   component: PrivilegesResolver(PrivilegesScreen),
  //   title: 'Мои льготы',
  // },
  {
    route: Screens.PrivilegesServiceDetails,
    webRoute: Routes.privilegesServiceDetails,
    component: PrivilegesResolver(PrivilegeDetailsScreen),
    title: 'Льгота',
  },
  {
    route: Screens.LoyaltyProgram,
    webRoute: Routes.loyaltyProgram,
    component: LoyaltyProgramScreen,
    title: 'Программа лояльности',
  },
  {
    route: Screens.VolunteersService,
    webRoute: Routes.volunteersService,
    component: VolunteersServiceScreen,
    title: 'Волонтерство',
  },
  {
    route: Screens.VolunteersServiceExchangeHistory,
    webRoute: Routes.volunteersServiceExchangeHistory,
    component: VolunteersServiceExchangeHistoryScreen,
    title: 'История пополнений транспортной карты',
  },
  {
    route: Screens.LoyaltyProgramAcceptor,
    webRoute: Routes.loyaltyProgramAcceptor,
    component: LoyaltyProgramAcceptorScreen,
    title: 'Партнер',
  },
  {
    route: Screens.SupportService,
    webRoute: Routes.supportService,
    component: SupportServiceScreen,
    title: 'Служба поддержки',
  },
  {
    route: Screens.StateAssignments,
    webRoute: Routes.stateAssignments,
    component: StateAssignmentsScreen,
    title: 'Государственные задания',
  },
  {
    route: Screens.StatePrograms,
    webRoute: Routes.statePrograms,
    component: StateProgramsScreen,
    title: 'Государственные программы',
  },
  {
    route: Screens.SupportServiceTopics,
    webRoute: Routes.supportServiceTopics,
    component: SupportServiceTopics,
    title: 'Мои обращения',
  },
  {
    route: Screens.SupportServiceCreateTopic,
    webRoute: Routes.supportServiceCreateTopic,
    component: CreateRequest,
    title: 'Новое обращение',
  },
  {
    route: Screens.SupportServiceTopic,
    webRoute: Routes.supportServiceTopic,
    component: SupportServiceTopic,
    title: 'Обращение',
  },
  {
    route: Screens.ExpenseLiabilities,
    webRoute: Routes.expenseLiabilities,
    component: ExpenseLiabilitiesScreen,
    title: 'Реестр расходных обязательств',
  },
  {
    route: Screens.SocialSupportMeasures,
    webRoute: Routes.socialSupportMeasures,
    component: SocialSupportMeasuresScreen,
    title: 'Меры социальной поддержки',
  },
  /*{
    route: Screens.Polls,
    webRoute: Routes.polls,
    component: PollsResolver(PollsMainScreen),
    title: 'Опросы и голосования',
  },
  {
    route: Screens.PollsTypeSurvey,
    webRoute: Routes.pollsTypeSurvey,
    component: PollsResolver(PollsTypeSurveyScreen),
    title: 'Опросы',
  },
  {
    route: Screens.PollsTypeVote,
    webRoute: Routes.pollsTypeVote,
    component: PollsResolver(PollsTypeVoteScreen),
    title: 'Голосования',
  },
  {
    route: Screens.PollsTypeSurveyForm,
    webRoute: Routes.pollsTypeSurveyForm,
    component: PollDetailsResolver(PollDetailsTypeResolver(PollsTypeSurveyFormScreen)),
    title: '',
  },
  {
    route: Screens.PollsTypeVoteForm,
    webRoute: Routes.pollsTypeVoteForm,
    component: PollDetailsResolver(PollDetailsTypeResolver(PollsTypeVoteFormScreen)),
    title: '',
  },*/
  {
    route: Screens.Notifications,
    webRoute: Routes.desktopNotifications,
    component: NotificationsScreen,
    title: 'Уведомления',
  },
  {
    route: Screens.News,
    webRoute: Routes.news,
    component: NewsScreen,
    title: 'Новости',
  },
  {
    route: Screens.NewsArticle,
    webRoute: Routes.newsArticle,
    component: NewsArticleScreen,
    title: 'Новость',
  },
  ...profileRoutes,
];

const Stack = createStackNavigator();

export const DesktopStackScreen = () => {
  const dispatch = useDispatch();
  const token = useSelector(profileTokenSelector());
  const profile = useSelector(holderProfileSelector());
  const [headerOffset, setHeaderOffset] = useState<number>(0);
  const visuallyImpairedSettings = useSelector(themeSelector());

  React.useEffect(() => {
    if (token && !profile) {
      initialLoading(dispatch);
    }
  }, [token]);
  const navs = token ? rootRoutes : unauthorizedRoutes;

  const dataViewAttrs = {
    dataSet: {
      class: 'header',
    },
  };

  return (
    <Stack.Navigator>
      {navs.map((menuItem) => (
        <Stack.Screen
          name={menuItem.route}
          key={menuItem.route}
          component={menuItem.component}
          options={({navigation, route}) => ({
            title: menuItem.title,
            headerTitle: () => <View />,
            headerLeft: () => <View />,
            headerBackground: () => (
              <View {...dataViewAttrs}>
                <VisuallyImpairedDesktop
                  active={!!visuallyImpairedSettings?.visuallyImpaired}
                  style={styles.visuallyImpairedDesktopWrapper}
                  onLayout={(event: LayoutChangeEvent) => {
                    setHeaderOffset(event.nativeEvent.layout.height);
                  }}
                />
                <Menu navigation={navigation} route={route} />
                <NoInternetNotification />
                <CardBlockedNotification />
              </View>
            ),
            headerStyle: {
              height: 0,
            },
            cardStyle: {paddingTop: headerOffset},
          })}
        />
      ))}
    </Stack.Navigator>
  );
};

const styles = StyleSheet.create({
  visuallyImpairedDesktopWrapper: {
    zIndex: 2,
    position: 'relative',
  },
});
